import type { ReactNode } from 'react';
import { useScenarios } from '../hooks/useScenarios';
import { ScenariosContext } from './ScenariosContextDefinition';

export function ScenariosProvider({ children }: { children: ReactNode }) {
  const scenariosHook = useScenarios();

  return (
    <ScenariosContext.Provider value={scenariosHook}>
      {children}
    </ScenariosContext.Provider>
  );
}

